/*
 * Broadcast Theme — Checks Downtown Custom JS
 */

(function() {
  'use strict';

  // ---- Remove price from Add to Cart button ---
  // Uses MutationObserver instead of document-level change listener
  function removeCartPrice() {
    document.querySelectorAll('.btn__price').forEach(function(el) { el.remove(); });
  }

  // ---- Accordion: orange title, plus prefix, toggle, first-accordion class ---
  function styleAccordions() {
    var summaries = document.querySelectorAll('.product__block--accordion .accordion__summary');
    summaries.forEach(function(summary, index) {
      var block = summary.closest('.product__block--accordion');

      if (index === 0 && block) {
        block.classList.add('first-accordion');
      }

      var title = summary.querySelector('.accordion__title');
      if (title) title.style.color = '#ff7135';

      var svgs = summary.querySelectorAll('svg, .accordion__icon, .icon');
      svgs.forEach(function(svg) { svg.style.display = 'none'; });

      summary.addEventListener('toggle', function() {
        var pre = summary.querySelector('.accordion-prefix');
        if (pre) pre.textContent = summary.parentElement.open ? '−' : '+';
      });
    });
  }

  // ---- Single DOMContentLoaded handler ---
  document.addEventListener('DOMContentLoaded', function() {
    removeCartPrice();
    styleAccordions();

    // Watch for dynamic button updates (variant changes, AJAX reloads)
    // Scoped to product form only, not the entire document
    var productForm = document.querySelector('.product__form, .product-form, form[action*="/cart/add"]');
    if (productForm) {
      var observer = new MutationObserver(removeCartPrice);
      observer.observe(productForm, { childList: true, subtree: true });
    }
  });

})();
